// extracted by mini-css-extract-plugin
export default {"prefixContainer":"FilterControl_prefixContainer__faO-4","iconWrapper":"FilterControl_iconWrapper__0CQ0f","filterName":"FilterControl_filterName__EygGm"};